module.exports = __webpack_public_path__ + "static/media/shipping-fast.276b5a21.svg";